import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { ensureNamespaces } from '../../i18n';
import { FaqAccordionList } from '../shared/faqAccordion/faqAccordion';
import { fetchFaqItems, selectFaqItems, selectFaqLoading } from '../../features/faq/faqSlice';
import { pickLang } from '../../utils/i18nDisplay';
import { faqVisibleOnMobile } from '../../utils/faqVisibility';
import { P } from '../../styles/styles';

import {
  LandingFaqInner,
  LandingFaqSection as LandingFaqSectionRoot,
  LandingFaqTitle,
} from './landingPage.styles';

export default function LandingFaqSection() {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(['landing', 'account']);
  const faqItems = useSelector(selectFaqItems);
  const loading = useSelector(selectFaqLoading);
  const lang = i18n.language?.split('-')?.[0] || 'en';

  useEffect(() => {
    ensureNamespaces(['landing']);
    dispatch(fetchFaqItems());
  }, [dispatch]);

  const displayItems = useMemo(
    () =>
      faqItems
        .filter(faqVisibleOnMobile)
        .map((item) => {
          const question = String(pickLang(item.question, lang) || '').trim();
          const answer = String(pickLang(item.answer, lang) || '').trim();
          if (!question || !answer) return null;
          return { id: item.id, question, answer };
        })
        .filter(Boolean),
    [faqItems, lang],
  );

  return (
    <LandingFaqSectionRoot id="faq">
      <LandingFaqInner>
        <LandingFaqTitle>{t('landing:faq.title')}</LandingFaqTitle>

        {loading && <P align="center">{t('account:faq.loading')}</P>}

        {!loading && displayItems.length === 0 && (
          <P align="center">{t('account:faq.empty')}</P>
        )}

        {!loading && displayItems.length > 0 && (
          <FaqAccordionList items={displayItems} />
        )}
      </LandingFaqInner>
    </LandingFaqSectionRoot>
  );
}
